import { forceUpdateKeys, requiredFields } from "@/src/components/Action/consts";
import { has } from "lodash";
import { useFormContext } from "react-hook-form";

const getKeysToUpdate = (formData: Record<string, any>, dirtyFields: Record<string, boolean>): Record<string, boolean> => {
  return {
    ...forceUpdateKeys.reduce((acc: Record<string, boolean>, key) => {
      if (has(formData, key)) {
        acc[key as string] = true;
      }
      return acc;
    }, {}),
    ...requiredFields.reduce((acc: Record<string, boolean>, key) => {
      if (formData[key]) {
        acc[key as string] = true;
      }
      return acc;
    }, {}),
    ...dirtyFields,
  };
};

export const useKeysToUpdate = () => {
  const { getValues, formState } = useFormContext();
  const { dirtyFields } = formState;
  return {
    getKeysToUpdate: () => getKeysToUpdate(getValues(), dirtyFields),
  };
}
